module.exports = __webpack_public_path__ + "media/images/emblems/Bever_wappen-493ebf181959ed1b941df1f47118fd2e.svg";